import { Info } from 'lucide-react';

interface WizardDialogProps {
  open: boolean;
  title: string;
  body: string;
  confirmLabel: string;
  /** Omit both for a single-acknowledgement dialog. */
  cancelLabel?: string;
  onConfirm: () => void;
  onCancel?: () => void;
}

export default function WizardDialog({
  open, title, body, confirmLabel, cancelLabel, onConfirm, onCancel,
}: WizardDialogProps) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4" role="dialog" aria-modal="true" aria-label={title}>
      <div className="fixed inset-0 bg-black/40" />
      <div className="card relative z-10 w-full max-w-lg p-8 text-center border-2 border-blue-600 dark:border-blue-500">
        <Info className="mx-auto h-6 w-6 text-blue-600 dark:text-blue-400" />
        <h3 className="mt-4 text-lg font-semibold text-blue-700 dark:text-blue-300">{title}</h3>
        <p className="mt-3 text-sm text-gray-600 dark:text-gray-300">{body}</p>
        <div className="mt-6 flex justify-center gap-3">
          <button type="button" onClick={onConfirm} className="btn-secondary">{confirmLabel}</button>
          {cancelLabel && onCancel && (
            <button type="button" onClick={onCancel} className="btn-secondary">{cancelLabel}</button>
          )}
        </div>
      </div>
    </div>
  );
}
